import client from '@/../lib/plugins/axios';

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function normalizeMessage(item) {
  if (!item) return null;

  const raw = item.data || item;

  const senderType = raw.sender_type || raw.senderType || raw.type || 'system';
  const typeMap = { ai: 'assistant', user: 'user', system: 'system' };

  const type = typeMap[senderType] || senderType;

  const files = [];
  let imageUrl = raw.main_banner_file || null;

  if (raw.file_path) {
    if (type === 'assistant') {
      imageUrl = raw.file_path;
    } else {
      files.push({
        id: raw.id,
        url: raw.file_path,
        type: 'image',
      });
    }
  }

  return {
    ...raw,
    type,
    imageUrl,
    files,
  };
}

export const chat = {
  async getHistory(bannerId) {
    const response = await client.get(`/api/chats/${bannerId}/messages`);

    let items = [];
    if (Array.isArray(response.data.data)) {
      items = response.data.data;
    } else if (Array.isArray(response.data)) {
      items = response.data;
    }

    items = items.map(normalizeMessage).filter(Boolean);
    items.reverse();

    return { data: { data: items } };
  },

  async sendMessage(bannerId, { text, file_path }) {
    return client.post(`/api/chats/${bannerId}/messages`, {
      text: text || null,
      file_path: file_path || null,
    });
  },

  async uploadImage(file) {
    const imageBase64 = await fileToBase64(file);

    const response = await client.post('/image-module/images', {
      image_base64: imageBase64,
    });

    return response.data;
  },

  normalizeMessage,
};
